import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum';

export default Object.freeze({
	GENERAL: `${RouteNames.CHANGELOGS}-general`,
	LOGS: `${RouteNames.CHANGELOGS}-logs`,
});
